import { ChangeEvent, InputHTMLAttributes, ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import tw from "twin.macro";

import ImageIcon from "../../assets/icons/Image.svg";
import { registerMock } from "../../utils";

interface Props {
  name: string;
  onChange?: (e: ChangeEvent) => void;
  disabled?: boolean;
  icon?: ReactNode;
  multiple?: boolean;
  className?: string;
}

export const ImagePicker = ({
  name,
  disabled = false,
  icon,
  multiple,
  className,
  ...props
}: Props & InputHTMLAttributes<HTMLInputElement>) => {
  const form = useFormContext();
  const register = form ? form.register : registerMock;
  const { onChange } = register(name);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e);
    if (props.onChange) props.onChange(e);
  };

  return (
    <label tw="cursor-pointer" htmlFor={name} className={className}>
      <input
        tw="hidden"
        id={name}
        type="file"
        disabled={disabled}
        multiple={multiple}
        {...register(name)}
        onChange={handleChange}
      />
      {icon ? (
        icon
      ) : (
        <ImageIcon
          tw="svg text-theme"
          css={disabled && tw`text-opacity-60 cursor-not-allowed`}
        />
      )}
    </label>
  );
};
